"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stimulus_1 = require("stimulus");
var google_analytics_event_tracker_1 = __importDefault(require("~/jquery-modules/google_analytics_event_tracker"));
var SendRegistrationEventController = /** @class */ (function (_super) {
    __extends(SendRegistrationEventController, _super);
    function SendRegistrationEventController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.connect = function () {
            var registrationType = _this.data.get('registrationType');
            registrationType && google_analytics_event_tracker_1.default.postGAEvent('会員登録', 'signup', registrationType);
        };
        return _this;
    }
    return SendRegistrationEventController;
}(stimulus_1.Controller));
exports.default = SendRegistrationEventController;
